import { AssistantThread } from 'types/AssistantTypes';
import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';

export const AssistantService = {
  newThread: async (): Promise<AssistantThread> => {
    return RestService.post(ApiRoutes.THREADS);
  },

  fetchReportData: async (portfolioId: string): Promise<any> => {
    return RestService.get(ApiRoutes.FINECO_PORTFOLIO_REPORT_DATA(portfolioId));
  },

  createProductCardPdf: async (isin: string): Promise<any> => {
    return RestService.download(ApiRoutes.CREATE_PRODUCT_CARD_PDF(isin));
  },

  fetchReportParameters: async (portfolioId: string): Promise<any> => {
    return RestService.get(ApiRoutes.FINECO_PORTFOLIO_REPORT_PARAMETERS(portfolioId));
  },

  createPdf: async (portfolioId: string, reportParameters: any): Promise<any> => {
    return RestService.post(
      ApiRoutes.FINECO_PORTFOLIO_REPORT_PDF(portfolioId),
      {
        report_parameters: reportParameters,
      },
      {
        responseType: 'blob',
      },
    );
  },

  createExcel: async (portfolioId: string): Promise<any> => {
    return RestService.get(ApiRoutes.FINECO_PORTFOLIO_REPORT_EXCEL(portfolioId), {
      responseType: 'blob',
    });
  },

  saveInMyPortfolio: async (portfolioId: string): Promise<any> => {
    return RestService.post(ApiRoutes.FINECO_PORTFOLIO_SAVE(portfolioId));
  },

  createComparisonPdf: async (portfolioId1: string, portfolioId2: string, reportParameters: any): Promise<any> => {
    return RestService.post(
      ApiRoutes.FINECO_PORTFOLIOS_COMPARE,
      {
        portfolio_id_1: portfolioId1,
        portfolio_id_2: portfolioId2,
        report_parameters: reportParameters,
      },
      {
        responseType: 'blob',
      },
    );
  },

  fetchPortfolioStory: async (portfolioId: string): Promise<any> => {
    return RestService.get(ApiRoutes.FINECO_PORTFOLIO_STORY(portfolioId));
  },
};
